import { ENERGY_SOURCE_KEY } from "../bisko/energy-source-key";
import { MethodologyType } from "../methodology/types";
import { GPC_METHODOLOGY_ID } from "./constants";
export const GPC_METHODOLOGY_LOOKUP_MAP = {
    type: MethodologyType.GPC,
    id: GPC_METHODOLOGY_ID,
    sectors: {
        STATIONARY_ENERGY: {
            id: "veqrd2az2utuwyl2jf7g1e3t",
            title: "Stationäre Energie",
            subsectors: {
                HOUSEHOLDS: {
                    id: "kj4nq8wpft2drm6h9zsxue03",
                    title: "Haushalte",
                },
                COMMERCIAL_AND_PUBLIC: {
                    id: "l7vb5nh3yc1qmp8koazfwr94",
                    title: "Kommerzielle und öffentliche Haushalte",
                    subsubsectors: {
                        COMMERCIAL_NON_MUNICIPAL: {
                            id: "g37dxug0wcq2q0wn41vlwax9",
                            title: "Gewerbe und nicht-kommunale Einrichtungen",
                        },
                        MUNICIPAL_BUILDINGS: {
                            id: "ln3y8gq14t8zy6vtbo9csg6b",
                            title: "Kommunale Gebäude und Anlagen",
                        },
                        PUBLIC_LIGHTING: {
                            id: "kainte7y61wy256pl9l279ug",
                            title: "Öffentliche Beleuchtung",
                        },
                        OTHER_MUNICIPAL: {
                            id: "vpf9d88qzs460cah1ne4w00n",
                            title: "Sonstige kommunale Einrichtungen",
                        },
                    },
                },
                INDUSTRY: {
                    id: "nx8mp2krfd6tjwq4ag5hbev9",
                    title: "Industrie",
                },
                AGRICULTURE_FORESTRY_FISHERIES: {
                    id: "dq2tnp4mksvw9rxbj7hg8lec",
                    title: "Landwirtschaft, Forstwirtschaft und Fischerei",
                },
                ENERGY_INDUSTRIES: {
                    id: "rt6jw9pmlfh3qsa8nvxk4uoy",
                    title: "Energiewirtschaft",
                },
                UNSPECIFIED_SOURCES: {
                    id: "vp5km8jhwntb3rax6dyfq9lo",
                    title: "Nicht spezifizierte Quellen",
                },
            },
            energySources: {
                NATURAL_GAS: { id: "gwxp4qa6tr6qid0o5rem6boy", title: "Erdgas", scope: 1, key: ENERGY_SOURCE_KEY.NATURAL_GAS },
                HEATING_OIL: { id: "my5kugikno4x13qayhrlmfka", title: "Heizöl", scope: 1, key: ENERGY_SOURCE_KEY.HEATING_OIL },
                LIQUID_GAS: {
                    id: "lhitxwsjdowahe6m1mssn3di",
                    title: "Flüssiggas",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.LPG_STATIONARY,
                },
                HARD_COAL: { id: "z2iulkreqj4qj5zkxo94fgyk", title: "Steinkohle", scope: 1, key: ENERGY_SOURCE_KEY.HARD_COAL },
                LIGNITE: { id: "lke4onp5sr9q6ypgw7pho1sx", title: "Braunkohle", scope: 1, key: ENERGY_SOURCE_KEY.LIGNITE },
                BIOMASS: { id: "xs0em6yxz64gq6is5y79jbal", title: "Biomasse", scope: 1, key: ENERGY_SOURCE_KEY.BIOMASS },
                BIOGAS: { id: "rdadnpb59u5gypdot24a2shl", title: "Biogas", scope: 1, key: ENERGY_SOURCE_KEY.BIOGAS },
                SOLAR_THERMAL: {
                    id: "kjfn4a6zynhvnxzqkf0zb79a",
                    title: "Solarthermie",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.SOLAR_THERMAL,
                },
                AMBIENT_HEAT: {
                    id: "hd4dokf7pi7fifb8uni1rfdt",
                    title: "Umweltwärme",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.ENVIRONMENTAL_HEAT,
                },
                OTHER_RENEWABLE: {
                    id: "fktwpip6u4obl8mmdpd0az8a",
                    title: "Sonstige Erneuerbare",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.OTHER_RENEWABLES,
                },
                OTHER_CONVENTIONAL: {
                    id: "s0qnkk8dgw1iiwnfenc9jrv6",
                    title: "Sonstige Konventionelle",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.OTHER_CONVENTIONAL,
                },
                ELECTRICITY: { id: "zrugky7ttlvu5qk0uagv2oj9", title: "Strom", scope: 2, key: ENERGY_SOURCE_KEY.ELECTRICITY },
                HEATING_ELECTRICITY: {
                    id: "dcmwn0s5w67dhh3wx2bg9f43",
                    title: "Heizstrom",
                    scope: 2,
                    key: ENERGY_SOURCE_KEY.ELECTRICITY_FOR_HEATING,
                },
                DISTRICT_HEATING: {
                    id: "lpv080f56jtik30m8f1m3voa",
                    title: "Fernwärme",
                    scope: 2,
                    key: ENERGY_SOURCE_KEY.DISTRICT_HEATING,
                },
                LOCAL_HEATING: {
                    id: "naivjp8a72zbdfg0dzka5kh8",
                    title: "Nahwärme",
                    scope: 2,
                    key: ENERGY_SOURCE_KEY.LOCAL_HEATING,
                },
                ELECTRICITY_GRID_LOSSES: { id: "s3sestromnetzverl0kq4t7x", title: "Strom (Netzverluste)", scope: 3 },
                HEATING_ELECTRICITY_GRID_LOSSES: { id: "s3seheizstromnv9m3plqz28", title: "Heizstrom (Netzverluste)", scope: 3 },
                DISTRICT_HEATING_GRID_LOSSES: { id: "s3sefernwaermenv4d7xrt93", title: "Fernwärme (Netzverluste)", scope: 3 },
                LOCAL_HEATING_GRID_LOSSES: { id: "s3senahwaermenv6k2plfh85", title: "Nahwärme (Netzverluste)", scope: 3 },
            },
        },
        TRANSPORTATION: {
            id: "vivvkpu8y8lrknfkoe7hsm0g",
            title: "Verkehr",
            subsectors: {
                PASSENGER_CARS: {
                    id: "hc4mp9krwf2tdj6naxlbev57",
                    title: "Personenkraftwagen",
                },
                MOTORIZED_TWO_WHEELERS: {
                    id: "gx7nq2pmwjbh5dlsftrvao89",
                    title: "Motorisierte Zweiräder",
                },
                LIGHT_COMMERCIAL_VEHICLES: {
                    id: "rt3kp8wfjd6hmqacnxylve52",
                    title: "Leichte Nutzfahrzeuge",
                },
                HEAVY_COMMERCIAL_VEHICLES: {
                    id: "sd5mn7pkwlb2hjqaxtrvf980",
                    title: "Schwere Nutzfahrzeuge",
                },
                TRANSIT_BUS: {
                    id: "vj8np3kwmftq6dhsaxlrce25",
                    title: "Linienbus",
                },
                COACHES: {
                    id: "bw4mq7nkldj5htsaxrcvfp93",
                    title: "Reisebusse",
                },
                LOCAL_RAIL: {
                    id: "zc6lp2nmwhfj9dkstxravu48",
                    title: "Schienenpersonennahverkehr",
                },
                LONG_DISTANCE_RAIL: {
                    id: "yj3nq8kpwlfh5mtsxdravc26",
                    title: "Schienenpersonenfernverkehr",
                },
                RAIL_FREIGHT: {
                    id: "pq7mn2lkwjhd6frcaxtsve89",
                    title: "Schienengüterverkehr",
                },
                TRAM_METRO: {
                    id: "ot5jp9nmwlfh3kdsaxrcve62",
                    title: "Stadt-, Straßen- und U-Bahn",
                },
                AVIATION: {
                    id: "kn6mp4lkwfhj8dtsaxrcve73",
                    title: "Flugverkehr",
                },
                INLAND_SHIPPING: {
                    id: "vm9nq3lkwfhj7dpsaxrcte48",
                    title: "Binnenschifffahrt",
                },
                OFF_ROAD: {
                    id: "rc4mp7lkwfhj2dnsaxgvtoe61",
                    title: "Off-Road",
                },
            },
            energySources: {
                GASOLINE: { id: "hd4dokf7pi7fifb8uni1rfdg", title: "Benzin", scope: 1, key: ENERGY_SOURCE_KEY.GASOLINE_FOSSIL },
                BIO_GASOLINE: {
                    id: "pvvkz4e0x3k0eiqzuy8atwdd",
                    title: "Biobenzin",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.GASOLINE_BIOGENIC,
                },
                DIESEL: { id: "l1cerli2zdzgvdqrsiy8hdv8", title: "Diesel", scope: 1, key: ENERGY_SOURCE_KEY.DIESEL_FOSSIL },
                DIESEL_BIOGENIC: {
                    id: "vao8o87ktc5upodv91znfnr3",
                    title: "Diesel biogen",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.DIESEL_BIOGENIC,
                },
                KEROSENE: { id: "m9hdcctw8oxguinl26ze2s2r", title: "Kerosin", scope: 1, key: ENERGY_SOURCE_KEY.KEROSENE },
                LPG: { id: "l35s1ykikz9khecrguj8cx40", title: "LPG", scope: 1, key: ENERGY_SOURCE_KEY.LPG_TRANSPORT },
                NATURAL_GAS_CNG_LNG: {
                    id: "l35s1ykikz9khecrguj8cx41",
                    title: "Erdgas (CNG + LNG)",
                    scope: 1,
                    key: ENERGY_SOURCE_KEY.NATURAL_GAS_CNG_LNG,
                },
                BIO_CNG: { id: "c455t6hztfxrse1rjo9m9e6i", title: "Bio-CNG", scope: 1, key: ENERGY_SOURCE_KEY.BIOGAS_TRANSPORT },
                ELECTRICITY: { id: "zrugky7ttlvu5qk0uagv2oj9", title: "Strom", scope: 2, key: ENERGY_SOURCE_KEY.ELECTRICITY },
                GASOLINE_CROSS_BORDER: { id: "s3trbenzingrenz7k2lpf093", title: "Benzin (grenzüberschreitend)", scope: 3 },
                BIO_GASOLINE_CROSS_BORDER: { id: "s3trbiobenzingr4d7xrt062", title: "Biobenzin (grenzüberschreitend)", scope: 3 },
                DIESEL_CROSS_BORDER: { id: "s3trdieselgrenz9m3plqz47", title: "Diesel (grenzüberschreitend)", scope: 3 },
                DIESEL_BIOGENIC_CROSS_BORDER: { id: "s3trdieselbiogengr6k2p08", title: "Diesel biogen (grenzüberschreitend)", scope: 3 },
                KEROSENE_CROSS_BORDER: { id: "s3trkerosingrenz4d7xr095", title: "Kerosin (grenzüberschreitend)", scope: 3 },
                LPG_CROSS_BORDER: { id: "s3trlpggrenzueb7k2lpf039", title: "LPG (grenzüberschreitend)", scope: 3 },
                NATURAL_GAS_CNG_LNG_CROSS_BORDER: { id: "s3trerdgascnglng9m3plq06", title: "Erdgas (CNG + LNG) (grenzüberschreitend)", scope: 3 },
                BIO_CNG_CROSS_BORDER: { id: "s3trbiocnggrenz4d7xrt018", title: "Bio-CNG (grenzüberschreitend)", scope: 3 },
                ELECTRICITY_CROSS_BORDER: { id: "s3trstromgrenzueb6k2pl07", title: "Strom (grenzüberschreitend)", scope: 3 },
            },
        },
        WASTE: {
            id: "abfwxk9p3lmqf2tdnxhrve56",
            title: "Abfall",
            subsectors: {
                LANDFILLS: {
                    id: "mudlp7r4kqwfh3jnzaxbve28",
                    title: "Mülldeponien",
                },
                BIOLOGICAL_WASTE_TREATMENT: {
                    id: "biabh5k7npmqfd3tjxlwer92",
                    title: "Biologische Abfallbehandlung",
                },
                WASTE_INCINERATION: {
                    id: "muvbn6p2lkfh8djtqrxwev54",
                    title: "Müllverbrennung",
                },
                WASTEWATER: {
                    id: "abwsr7m4nkpfh2djtqxlve03",
                    title: "Abwasser",
                },
            },
            // Waste is a calculated sector (activity × factor), not a direct-emission
            // one. Its "energy sources" are the activity-row dimension of the grid:
            // waste-composition fractions for the solid subsectors (Deponie /
            // Kompostierung / Verbrennung, activity in tonnes), and a treated-volume
            // basis (Abwasser in m³) for Abwasser. Each carries an emission factor that varies by
            // pathway (subsector) — see waste-factors.ts. All scope 1 for v1; the
            // scope-3 (exported waste) split is deferred.
            energySources: {
                ORGANIC: { id: "worgnk4p2lmfh7djtxabve61", title: "Organik / Bioabfall", scope: 1 },
                PAPER: { id: "wpapr8k3nlqfh2djtxsbve47", title: "Papier / Pappe", scope: 1 },
                WOOD: { id: "wholz5m7kpqfh4djtnxrve29", title: "Holz", scope: 1 },
                TEXTILES: { id: "wtextl3p9kmfh6djtnxave85", title: "Textilien", scope: 1 },
                PLASTICS: { id: "wkunst7k2lpfh3djtnxrve52", title: "Kunststoffe", scope: 1 },
                RESIDUAL_WASTE: { id: "wrestm6p4klfh8djtnxave73", title: "Restmüll (gemischt)", scope: 1 },
                WASTEWATER_VOLUME: { id: "weinwh9k3lpfh2djtnxrve18", title: "Abwasser", scope: 1 },
            },
        },
        IPPU: {
            id: "ippuk5p3mlqfh4djtnxrwev71",
            title: "IPPU",
            subsectors: {
                INDUSTRIAL_PROCESSES: {
                    id: "indpr7k4mlqfh3djtnxrwev82",
                    title: "Industrielle Prozesse",
                },
                PRODUCT_USE: {
                    id: "prduv6m4lkpqfh3jtnxrwev95",
                    title: "Produktverwendung",
                },
            },
            // IPPU is a calculated sector (activity × factor), like Waste. Its "energy
            // sources" are the activity-row dimension of the grid: process categories
            // (Industrielle Prozesse) and product categories (Produktverwendung), all
            // activity in tonnes. Each carries an emission factor that depends on the
            // category × subsector cell — see ippu-factors.ts. All scope 1 (GPC reports
            // IPPU under scope 1 only). The category set + factors below are PLACEHOLDERS
            // to be replaced with authoritative values.
            energySources: {
                CEMENT: { id: "ippzement4lmfh7djtxrv001", title: "Zementproduktion", scope: 1 },
                LIME: { id: "ippkalkx72mlpfh4djtnv002", title: "Kalkproduktion", scope: 1 },
                GLASS: { id: "ippglasx63nkqfh8djtmv003", title: "Glasproduktion", scope: 1 },
                CERAMICS: { id: "ippkeram5p9kmfh6djtnv004", title: "Keramikproduktion", scope: 1 },
                CHEMICALS_AMMONIA: { id: "ippchem7k2lpfh3djtnxv005", title: "Chemie (Ammoniak/Salpetersäure)", scope: 1 },
                METAL_IRON_STEEL: { id: "ippmetal8k4lqfh3djtnv006", title: "Metallproduktion (Eisen/Stahl)", scope: 1 },
                REFRIGERANTS_AC: { id: "ippkaelt6m4lkpqfhjtnv007", title: "Kältemittel / Klimaanlagen", scope: 1 },
                FOAMS: { id: "ippscha9p3lmqfh4djtnv008", title: "Schaumstoffe", scope: 1 },
                ELECTRICAL_EQUIPMENT: { id: "ippelek4p3lmfh5djtnxv009", title: "Elektrische Betriebsmittel (SF₆)", scope: 1 },
                SOLVENTS: { id: "ipploes5m4lkpqfhjtnxv010", title: "Lösungsmittel / Schmierstoffe", scope: 1 },
            },
        },
        AFOLU: {
            id: "afolu4p3lmqfh5djtnxrwev63",
            title: "AFOLU",
            subsectors: {
                LIVESTOCK: {
                    id: "tierh8k4lmqfh3djtnxrwev41",
                    title: "Tierhaltung",
                },
                LAND_USE: {
                    id: "landn5m4lkpqfh3jtnxrwev27",
                    title: "Landnutzung, Landnutzungsänderung und Forstwirtschaft",
                },
                OTHER: {
                    id: "sonst9p3lmqfh4djtnxrwev58",
                    title: "Sonstige",
                },
            },
            // AFOLU is a calculated sector (activity × factor), like Waste and IPPU. Its
            // "energy sources" are the activity-row dimension of the grid: livestock
            // categories (Tierhaltung, activity per animal), land-use categories
            // (Landnutzung, activity in hectares — a CO₂ factor may be negative where the
            // land is a net carbon sink, e.g. rewetted organic wetlands) and other
            // agricultural sources (Sonstige, activity in tonnes). Each carries an
            // emission factor that depends on the category × subsector cell — see
            // afolu-factors.ts. All scope 1.
            energySources: {
                CATTLE: { id: "aforinder4lmfh7djtxv001", title: "Rinder", scope: 1 },
                PIGS: { id: "afoschweine5kmfh6djv002", title: "Schweine", scope: 1 },
                POULTRY: { id: "afogefluegel2lpfhjv003", title: "Geflügel", scope: 1 },
                SHEEP_GOATS: { id: "afoschafzieg8k4lqfv004", title: "Schafe und Ziegen", scope: 1 },
                HORSES: { id: "afopferde6m4lkpqhjv005", title: "Pferde / sonstige Tiere", scope: 1 },
                FOREST: { id: "afowald4p3lmfh5djtv006", title: "Wald / Forstwirtschaft", scope: 1 },
                CROPLAND: { id: "afoackerland9p3lmqv007", title: "Ackerland", scope: 1 },
                GRASSLAND: { id: "afogruenland5m4lkpv008", title: "Grünland", scope: 1 },
                WETLANDS: { id: "afofeuchtgeb6m4lkpv009", title: "Feuchtgebiete", scope: 1 },
                SETTLEMENTS: { id: "afosiedlung4p3lmfhv010", title: "Siedlungen", scope: 1 },
                LIMING: { id: "afokalkung72mlpfhjv011", title: "Kalkung", scope: 1 },
                UREA: { id: "afoharnstoff63nkqfv012", title: "Harnstoffanwendung", scope: 1 },
                CROP_RESIDUES: { id: "afoernteruecks5p9kv013", title: "Ernterückstände", scope: 1 },
            },
        },
    },
};
